export const initValues = {employee:"",type:"",plannedVacationDatesArr:null,replacement:null,comment:""}